module.exports = __webpack_public_path__ + "static/img/App item-3.3c595d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls39/App item-3.png
// module id = CcAR
// module chunks = 12